export const select2DefaultOption = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}

export const select2DefaultWithSearchBox = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: 0
}

export const readonlyOption = {
    disabled: true
}